import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { logError } from "@faire/web--source/common/logging";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import chunk from "lodash/chunk";
import isUndefined from "lodash/isUndefined";
import React from "react";
export var EfficientListLoader = function(props) {
    return /*#__PURE__*/ _jsx(EfficientListLoaderBase, _object_spread({}, props), props.hashKey);
};
export var EfficientListLoaderBase = function(props) {
    var _props_batchSize;
    if (((_props_batchSize = props.batchSize) !== null && _props_batchSize !== void 0 ? _props_batchSize : 0) < 0) {
        logError("Batch size must be positive!");
    }
    // if batch size is 0 default to 1
    var batchSize = props.batchSize || 1;
    var batchedData = props.filterFakeTile ? chunk(props.data, batchSize).map(function(chunkData) {
        return chunkData.filter(function(data) {
            return !(data === null || data === void 0 ? void 0 : data.fake);
        });
    }) : chunk(props.data, batchSize);
    var batchEventData = props.eventData ? chunk(props.eventData, batchSize) : undefined;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: batchedData.map(function(group, groupIndex) {
            var _props_placeholderFn;
            if (groupIndex === 0) {
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Group, {
                            group: group,
                            groupIndex: groupIndex,
                            renderComponent: props.renderComponent,
                            onBatchVisible: props.onBatchVisible,
                            batchSize: batchSize,
                            visibilityWrapperDisplayProperty: props.visibilityWrapperDisplayProperty,
                            batchEventData: batchEventData === null || batchEventData === void 0 ? void 0 : batchEventData[groupIndex]
                        }, groupIndex),
                        props.componentToInsert && props.componentToInsert.groupIndex === groupIndex ? props.componentToInsert.component : null
                    ]
                }, groupIndex);
            }
            if (props.renderPlaceholderForNonFirstBatch && props.placeholderFn) {
                return props.placeholderFn(group, groupIndex);
            }
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: /*#__PURE__*/ _jsxs(WhenVisibilityIsImminent, {
                    customizePlaceholder: (_props_placeholderFn = props.placeholderFn) === null || _props_placeholderFn === void 0 ? void 0 : _props_placeholderFn.call(props, group, groupIndex),
                    forceRender: props.forceRender,
                    threshold: props.threshold,
                    useTransition: props.useTransition,
                    children: [
                        /*#__PURE__*/ _jsx(Group, {
                            group: group,
                            groupIndex: groupIndex,
                            renderComponent: props.renderComponent,
                            onBatchVisible: props.onBatchVisible,
                            batchSize: batchSize,
                            visibilityWrapperDisplayProperty: props.visibilityWrapperDisplayProperty,
                            batchEventData: batchEventData === null || batchEventData === void 0 ? void 0 : batchEventData[groupIndex]
                        }, groupIndex),
                        props.componentToInsert && props.componentToInsert.groupIndex === groupIndex ? props.componentToInsert.component : null
                    ]
                })
            }, groupIndex);
        })
    });
};
var Group = function(param) {
    var group = param.group, groupIndex = param.groupIndex, renderComponent = param.renderComponent, onBatchVisible = param.onBatchVisible, batchSize = param.batchSize, _param_visibilityWrapperDisplayProperty = param.visibilityWrapperDisplayProperty, visibilityWrapperDisplayProperty = _param_visibilityWrapperDisplayProperty === void 0 ? "inherit" : _param_visibilityWrapperDisplayProperty, batchEventData = param.batchEventData;
    var viewRef = useDoActionWhenVisible(function() {
        onBatchVisible === null || onBatchVisible === void 0 ? void 0 : onBatchVisible(group, groupIndex, batchEventData);
    });
    if (group.every(isUndefined) && !batchEventData) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: group.map(function(item, index) {
                return /*#__PURE__*/ _jsx(React.Fragment, {
                    children: renderComponent(item, groupIndex * batchSize + index)
                }, index);
            })
        });
    } else {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: group.map(function(item, index) {
                if (item === null || item === void 0 ? void 0 : item.fake) {
                    return null;
                } else if (index === 0) {
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: visibilityWrapperDisplayProperty
                        },
                        ref: viewRef,
                        children: renderComponent(item, groupIndex * batchSize + index)
                    }, "fireevent-".concat(groupIndex));
                } else {
                    return /*#__PURE__*/ _jsx(React.Fragment, {
                        children: renderComponent(item, groupIndex * batchSize + index)
                    }, "item-".concat(groupIndex, "-").concat(index));
                }
            })
        });
    }
};
